
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, FinancialClosing, PageOptions } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class FinancialClosingListProvider implements Resolve<any> {
    financialClosing: FinancialClosing[];
    financialClosingEdit: FinancialClosing;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.financialClosingEdit = this.state?.currentFinancialClosing;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'dated';
        }
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    get(id: number): Observable<FinancialClosing> {
        if (!id) {
            return null;
        }
        return this.gw.get('financialClosing/:id', { id: id });
    }

    get currentFinancialClosing(): FinancialClosing {
        return this.financialClosingEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('financialClosing/').subscribe({
                next: (res: HttpResponse<any>) => {
                    this.financialClosing = res.body;
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });

    }

    getPage(pageOptions: PageOptions, type): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(`financialClosing/search/${type}`, pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    if (!CwUtils.compare(this.financialClosing, res.body.content) && res.body.content.length > 0) {
                        this.financialClosing = res.body.content;
                        this.onDataChanged.next(this.financialClosing);
                    }
                    else {
                        this.financialClosing = res.body.content;
                    };
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

